import { Navigate, createBrowserRouter } from "react-router-dom";

/**ADMIN ROUTE START */
import AdminLayout from "./modules/admin/shared/adminlayout";
import Login from "./modules/admin/pages/login";
import PrivateRoute from "./modules/admin/shared/privateRoute";
import PublicRoute from "./modules/admin/shared/publicRoute";
import Profile from "./modules/admin/pages/profile";
import EditProfile from "./modules/admin/pages/editprofile";
import Changepassword from "./modules/admin/pages/changepassword";
import OtpVerificationPage from "./modules/admin/pages/otpverification";
import ForgotPwdPage from "./modules/admin/pages/forgotpassword";
import ResetPwdPage from "./modules/admin/pages/resetpwd";
import Error404 from "./modules/admin/pages/404";
import Dashboard from "./modules/admin/pages/dashboard";
import EmailTemplatesTable from "./modules/admin/pages/cms/automaticemailtemplates/list";
import EmailTempAdd from "./modules/admin/pages/cms/automaticemailtemplates/add";
import EmailTempEdit from "./modules/admin/pages/cms/automaticemailtemplates/edit";
import ViewEmailTemp from "./modules/admin/pages/cms/automaticemailtemplates/view";
import GlobalSettings from "./modules/admin/pages/cms/settings/settings";
import UsersTable from "./modules/admin/pages/usermgmt/list";
import UsersView from "./modules/admin/pages/usermgmt/view";
import UsersAdd from "./modules/admin/pages/usermgmt/add";
import UserEdit from "./modules/admin/pages/usermgmt/edit";
import DoctorList from "./modules/admin/pages/doctors/list";
import DoctorAdd from "./modules/admin/pages/doctors/add";
import DoctorView from "./modules/admin/pages/doctors/view";
import DoctorEdit from "./modules/admin/pages/doctors/edit";
import AdminUnAuthLayout from "./modules/admin/shared/adminUnAuthLayout";
import AddMedicine from "./modules/admin/pages/medicineManagement/add";
import MedicineTable from "./modules/admin/pages/medicineManagement/list";
import MedicineView from "./modules/admin/pages/medicineManagement/view";
import MedicineEdit from "./modules/admin/pages/medicineManagement/edit";
import GlobalLayout from "./modules/GlobalLayout";
import PageAdd from "./modules/admin/pages/cms/pages/add";
import PageEdit from "./modules/admin/pages/cms/pages/edit";
import PageTable from "./modules/admin/pages/cms/pages/list";
import PageView from "./modules/admin/pages/cms/pages/view";
import FAQView from "./modules/admin/pages/cms/faq/view";
import FAQTable from "./modules/admin/pages/cms/faq/list";
import FAQAdd from "./modules/admin/pages/cms/faq/add";
import FAQEdit from "./modules/admin/pages/cms/faq/edit";

/** ----------------- CENTER --------------- */
import CenterPrivateRoute from "./modules/center/shared/centerPrivateRoute";
import CenterPublicRoute from "./modules/center/shared/publicRoute";
import Verifyotp from "./modules/center/pages/auth/verifyotp";
import CenterLayout from "./modules/center/shared/centerLayout";
import CenterAuthLayout from "./modules/center/shared/centerAuthLayout";
import CenterForgotPwdPage from "./modules/center/pages/auth/forgot_password";
import CenterLogin from "./modules/center/pages/auth/login";
import CenterResetPassword from "./modules/center/pages/auth/resetPassword";
import SelectUser from "./modules/center/pages/auth/selectUser";
import Page404 from "./modules/center/404Page/page404";
import CenterDashboard from "./modules/center/pages/dashboard/CenterDashboard";
import Doctor from "./modules/center/pages/settings/Doctor";
import Schedule from "./modules/center/pages/settings/Schedule";
import Wallet from "./modules/center/pages/settings/Wallet";


import DoctorAuthLayout from "./modules/doctor/shared/doctorAuthLayout";
import DoctorPrivateRoute from "./modules/doctor/shared/doctorPrivateRoute";
import DoctorMyProfile from "./modules/doctor/pages/profile/pages/DoctorMyProfile";
import DoctorLayout from "./modules/doctor/shared/doctorLayout";
import CenterProfile from "./modules/center/pages/profile/CenterProfile";
import CenterProfileChangePassword from "./modules/center/pages/profile/ProfileChangePassword";
import Patients from "./modules/center/pages/settings/Patient";
import Appointment from "./modules/center/pages/settings/Appointment";
import DoctorDashboard from "./modules/doctor/pages/dashboard/DoctorDashboard";
import Patient from "./modules/doctor/pages/settings/patient";
import DoctorProfileChangePassword from "./modules/doctor/pages/profile/pages/ProfileChangePassword";
import PatientAppointment from "./modules/doctor/pages/settings/Appointment";
import ConsultationHistory from "./modules/doctor/pages/settings/consulationHistory";
import PatientView from "./modules/doctor/pages/settings/viewPatient";
import MedicalHistoryView from "./modules/doctor/pages/settings/medicalHistoryView";
import ConsultationHistoryView from "./modules/doctor/pages/settings/viewConsulationHistroy";
import ConsultationMedicalHistoryView from "./modules/doctor/pages/settings/consulationMedicalHistory";
import PrescriptionCreate from "./modules/doctor/pages/settings/PrescriptionCreate";
import PrescriptionEdit from "./modules/doctor/pages/settings/PrescriptionEdit";
import CenterPatientView from "./modules/center/pages/settings/viewPatient";
import CenterDoctorPrivateRoute from "./modules/doctor/centerDoctorPrivateRoute";



import WebsiteLayout from "./modules/website/shared/layout";
import WebsiteHomePage from "./modules/website/pages/homePage";
import WebsiteAboutUs from "./modules/website/pages/aboutUs";
import Blog from "./modules/website/pages/blog";
import BlogDetail from "./modules/website/pages/blogDetail";
import OurDoctors from "./modules/website/pages/ourDoctors";
import WebsitePrivacyPolicy from "./modules/website/pages/privacyPolicy";
import Faq from "./modules/website/pages/Faq";
import DynamicWebPage from "./modules/website/pages/DynamicPage";
import WebsiteTerms from "./modules/website/pages/terms";
import InquiryTable from "./modules/admin/pages/inquiry/list";
import ViewInquiry from "./modules/admin/pages/inquiry/view";
import WebsiteInquiry from "./modules/website/common/inquiry";
import StaffAdd from "./modules/admin/pages/staff/add";
import StaffTable from "./modules/admin/pages/staff/list";
import StaffEdit from "./modules/admin/pages/staff/edit";
import StaffView from "./modules/admin/pages/staff/view";
import AppointmentAdd from "./modules/admin/pages/appointments/add";
import AppointmentTable from "./modules/admin/pages/appointments/list";
import AppointmentEdit from "./modules/admin/pages/appointments/edit";
import AppointmentView from "./modules/admin/pages/appointments/view";
import PermissionsTable from "./modules/admin/permissions/list";
import PatientTables from "./modules/admin/pages/patientManagement/list";
import PatientAdd from "./modules/admin/pages/patientManagement/add";
import ViewPatient from "./modules/admin/pages/patientManagement/view";
import PatientEdit from "./modules/admin/pages/patientManagement/edit";
import VideoTable from "./modules/admin/pages/cms/video/list";
import VideoAdd from "./modules/admin/pages/cms/video/add";
import VideoEdit from "./modules/admin/pages/cms/video/edit";
import VideoView from "./modules/admin/pages/cms/video/view";
import ReportView from "./modules/admin/pages/reports/reports";
import PatientReportTables from "./modules/admin/pages/reports/patientReport";
import MedicineReportTable from "./modules/admin/pages/reports/medicineReprt";
import EarningReportTable from "./modules/admin/pages/reports/earningReport";
import PrescriptionView from "./modules/doctor/pages/settings/PrescriptionView";
import DoctorSpecializationTable from "./modules/admin/pages/doctorSpecialization/list";
import AddDoctorSpecialization from "./modules/admin/pages/doctorSpecialization/add";
import DoctorSpecializationEdit from "./modules/admin/pages/doctorSpecialization/edit";
import DoctorSpecializationView from "./modules/admin/pages/doctorSpecialization/view";
import PatientDietChart from "./modules/doctor/pages/settings/patientDietChart";
import AppointmentsView from "./modules/admin/pages/staffAppointments/appointments";
import UpcomingAppointmentsTables from "./modules/admin/pages/staffAppointments/upcomingAppointment";
import AppointmentsTables from "./modules/admin/pages/staffAppointments/appointmentCompleted";
import AppointmentHistory from "./modules/admin/pages/staffAppointments/viewAppointmentHistory";
import AppointmentsCancelledTables from "./modules/admin/pages/staffAppointments/appointmentCancel";
import BlogTable from "./modules/admin/pages/cms/blog/list";
import BlogAdd from "./modules/admin/pages/cms/blog/add";
import BlogEdit from "./modules/admin/pages/cms/blog/edit";
import BlogView from "./modules/admin/pages/cms/blog/view";
import BannerTable from "./modules/admin/pages/cms/banner/list";
import BannerAdd from "./modules/admin/pages/cms/banner/add";
import BannerEdit from "./modules/admin/pages/cms/banner/edit";
import BannerView from "./modules/admin/pages/cms/banner/view";
import AboutUsAdd from "./modules/admin/pages/cms/aboutUs/add";
import ExpertGuidance from "./modules/admin/pages/cms/expertGuidance/add";
import WelcomeComponent from "./modules/TestComo";
import FranchiseInquiryTable from "./modules/admin/pages/franchiseinquiry/list";
import ViewFranchiseInquiry from "./modules/admin/pages/franchiseinquiry/view";
import ExpiredAppointmentsTables from "./modules/admin/pages/staffAppointments/expiredAppointment";
import AppointmentsFeedbackTables from "./modules/admin/pages/staffAppointments/appointmentCompletedFeedback";
import { ROLE } from "./utils/Constants";
import MedicalConditionsTable from "./modules/admin/pages/medicalConditions/list";
import AddMedicalCondition from "./modules/admin/pages/medicalConditions/add";
import EditMedicalCondition from "./modules/admin/pages/medicalConditions/edit";
import ViewMedicalCondition from "./modules/admin/pages/medicalConditions/view";
import DoctorExtraDetails from "./modules/admin/pages/doctors/ExtraDetails";
import CentreTestimonialsList from "./modules/admin/pages/usermgmt/extraDetails/centreTestimonials/list";
import CentreTestimonialsEdit from "./modules/admin/pages/usermgmt/extraDetails/centreTestimonials/edit";
import CentreTestimonialsView from "./modules/admin/pages/usermgmt/extraDetails/centreTestimonials/view";
import CentreTestimonialAdd from "./modules/admin/pages/usermgmt/extraDetails/centreTestimonials/add";
import VideoCategoryTable from "./modules/admin/pages/cms/videoCategory/list";
import ViewVideoCategory from "./modules/admin/pages/cms/videoCategory/view";
import AddVideoCategory from "./modules/admin/pages/cms/videoCategory/add";
import EditVideoCategory from "./modules/admin/pages/cms/videoCategory/edit";
import EducationalVideoTable from "./modules/admin/pages/usermgmt/extraDetails/EducationalVideos/list";
import EducationalVideoAdd from "./modules/admin/pages/usermgmt/extraDetails/EducationalVideos/add";
import EducationalVideoEdit from "./modules/admin/pages/usermgmt/extraDetails/EducationalVideos/edit";
import EducationalVideoView from "./modules/admin/pages/usermgmt/extraDetails/EducationalVideos/view";
import CenterServiceAdd from "./modules/admin/pages/usermgmt/extraDetails/CentreServices/add";
import CenterServiceEdit from "./modules/admin/pages/usermgmt/extraDetails/CentreServices/edit";
import CenterServiceView from "./modules/admin/pages/usermgmt/extraDetails/CentreServices/view";
import CenterServiceTable from "./modules/admin/pages/usermgmt/extraDetails/CentreServices/list";
import CenterSpecializationTable from "./modules/admin/pages/usermgmt/extraDetails/centerSpecialization/list";
import CenterSpecializationAdd from "./modules/admin/pages/usermgmt/extraDetails/centerSpecialization/add";
import CenterSpecializationEdit from "./modules/admin/pages/usermgmt/extraDetails/centerSpecialization/edit";
import CenterSpecializationView from "./modules/admin/pages/usermgmt/extraDetails/centerSpecialization/view";


const router = createBrowserRouter([

  {
    path: "/", element: <GlobalLayout />,
    children: [

      /** Pages for website start >>>>  */
      // {
      //   path: "/",
      //   element: <WebsiteLayout />,
      //   children: [
      //     { path: "", element: <WebsiteHomePage /> },
      //     { path: "/about-us", element: <WebsiteAboutUs /> },
      //     { path: "/blogs", element: <Blog /> },
      //     { path: "/blog-detail/:slug", element: <BlogDetail /> },
      //     { path: "/our-doctors", element: <OurDoctors /> },
      //     // { path: "/contact-us", element: <WebsiteContactUs /> },
      //     // { path: "/privacy-policy", element: <WebsitePrivacyPolicy /> },
      //     // { path: "/terms-conditions", element: <WebsiteTerms /> },
      //     // { path: "/help-support", element: <WebsiteHelpSupport /> },
      //     { path: "/contact-us", element: <WebsiteInquiry /> },
      //     { path: "/faq", element: <Faq /> },
      //     { path: "/inquiry", element: <WebsiteInquiry /> },
      //     { path: "/:slug", element: <DynamicWebPage /> },
      //     { path: "*", element: <Page404 /> },
      //   ],
      // },
      /** Pages for website end <<<<  */

      /**ADMIN ROUTE START */
      //  {
      // path: "/",
      //   element: <ExternalRedirect url="http://localhost:3000" />,
      // },
      {
        path: "",
        element: <WelcomeComponent />,
      },
      {
        path: "admin",
        element: <PrivateRoute component={AdminLayout} />,
        children: [
          {
            path: "",
            element: <Navigate to={"/admin/dashboard/1"} />,
          },
          {
            path: "dashboard/:pgno",
            element: <PrivateRoute component={Dashboard} />,
          },
          {
            path: "profile",
            element: <PrivateRoute component={Profile} />,
            children: [
              {
                path: "edit/:id",
                element: <PrivateRoute component={EditProfile} />,
              },
              {
                path: "change-password/:id",
                element: <PrivateRoute component={Changepassword} />,
              },
            ],
          },

          {
            /** Centre Management Route Start */
          },
          {
            path: "center-management/center/list/:pgno",
            element: <PrivateRoute component={UsersTable} requiredPermission="center_management" />,
          },
          {
            path: "center-management/center/add",
            element: <PrivateRoute component={UsersAdd} requiredPermission="center_management" />,
          },
          {
            path: "center-management/center/:pgno/edit/:id",
            element: <PrivateRoute component={UserEdit} requiredPermission="center_management" />,
          },
          {
            path: "center-management/center/view/:id",
            element: <PrivateRoute component={UsersView} requiredPermission="center_management" />,
          },
          // centre extra details 
          {
            path: "center-management/center/testimonial/:id/list/:pgno",
            element: <PrivateRoute component={CentreTestimonialsList} requiredPermission="center_management" />,
          },
          {
            path: "center-management/center/testimonial/add/:center_id",
            element: <PrivateRoute component={CentreTestimonialAdd} requiredPermission="center_management" />,
          },
          {
            path: "center-management/center/testimonial/:pgno/edit/:id",
            element: <PrivateRoute component={CentreTestimonialsEdit} requiredPermission="center_management" />,
          },
          {
            path: "center-management/center/testimonial/view/:id",
            element: <PrivateRoute component={CentreTestimonialsView} requiredPermission="center_management" />,
          },

          {
            path: "center-management/center/educational-video/:center_id/list/:pgno",
            element: <PrivateRoute component={EducationalVideoTable} requiredPermission="center_management" />,
          },
          {
            path: "center-management/center/educational-video/add/:center_id",
            element: <PrivateRoute component={EducationalVideoAdd} requiredPermission="center_management" />,
          },
          {
            path: "center-management/center/educational-video/:pgno/edit/:id",
            element: <PrivateRoute component={EducationalVideoEdit} requiredPermission="center_management" />,
          },
          {
            path: "center-management/center/educational-video/view/:id",
            element: <PrivateRoute component={EducationalVideoView} requiredPermission="center_management" />,
          },

          {
            path: "center-management/center/service/:center_id/list/:pgno",
            element: <PrivateRoute component={CenterServiceTable} requiredPermission="center_management" />,
          },
          {
            path: "center-management/center/service/add/:center_id",
            element: <PrivateRoute component={CenterServiceAdd} requiredPermission="center_management" />,
          },
          {
            path: "center-management/center/service/:pgno/edit/:id",
            element: <PrivateRoute component={CenterServiceEdit} requiredPermission="center_management" />,
          },
          {
            path: "center-management/center/service/view/:id",
            element: <PrivateRoute component={CenterServiceView} requiredPermission="center_management" />,
          },
          
          {
            path: "center-management/center/specialization/:center_id/list/:pgno",
            element: <PrivateRoute component={CenterSpecializationTable} requiredPermission="center_management" />,
          },
          {
            path: "center-management/center/specialization/add/:center_id",
            element: <PrivateRoute component={CenterSpecializationAdd} requiredPermission="center_management" />,
          },
          {
            path: "center-management/center/specialization/:pgno/edit/:id",
            element: <PrivateRoute component={CenterSpecializationEdit} requiredPermission="center_management" />,
          },
          {
            path: "center-management/center/specialization/view/:id",
            element: <PrivateRoute component={CenterSpecializationView} requiredPermission="center_management" />,
          },
          //centre extra details end
          {
            /** Centre Management Route End */
          },
          {
            /** Patient Management Route Start */
          },
          {
            path: "patient-management/patient/list/:pgno",
            element: <PrivateRoute component={PatientTables} requiredPermission="patient_management" />,
          },
          {
            path: "patient-management/patient/add",
            element: <PrivateRoute component={PatientAdd} requiredPermission="patient_management" />,
          },
          {
            path: "patient-management/patient/:pgno/edit/:id",
            element: <PrivateRoute component={PatientEdit} requiredPermission="patient_management" />,
          },
          {
            path: "patient-management/patient/view/:id",
            element: <PrivateRoute component={ViewPatient} requiredPermission="patient_management" />,
          },
          {
            /** Patient Management Route End */
          },
          {
            /** Staff  Route Start */
          },
          {
            path: "staff/list/:pgno",
            element: <PrivateRoute component={StaffTable} requiredPermission="staff_management" />,
          },
          {
            path: "staff/add",
            element: <PrivateRoute component={StaffAdd} requiredPermission="staff_management" />,
          },
          {
            path: "staff/:pgno/edit/:id",
            element: <PrivateRoute component={StaffEdit} requiredPermission="staff_management" />,
          },
          {
            path: "staff/view/:id",
            element: <PrivateRoute component={StaffView} requiredPermission="staff_management" />,
          },
          {
            /** Staff  Route End */
          },
          {
            /** Appointment  Route Start */
          },
          {
            path: "appointment/list/:pgno",
            element: <PrivateRoute component={AppointmentTable} requiredPermission="appointment_management" />,
          },
          {
            path: "appointment/add",
            element: <PrivateRoute component={AppointmentAdd} requiredPermission="appointment_management" />,
          },
          {
            path: "appointment/:pgno/edit/:id",
            element: <PrivateRoute component={AppointmentEdit} requiredPermission="appointment_management" />,
          },
          {
            path: "appointment/view/:id",
            element: <PrivateRoute component={AppointmentView} requiredPermission="appointment_management" />,
          },
          {
            /** Appointment  Route End */
          },
          /** CMS Route Start */
          {
            path: "cms/pages/list/:pgno",
            element: <PrivateRoute component={PageTable} requiredPermission="cms_page" />,
          },
          {
            path: "cms/pages/add",
            element: <PrivateRoute component={PageAdd} requiredPermission="cms_page" />,
          },
          {
            path: "cms/pages/:pgno/edit/:id",
            element: <PrivateRoute component={PageEdit} requiredPermission="cms_page" />,
          },
          {
            path: "cms/pages/view/:id",
            element: <PrivateRoute component={PageView} requiredPermission="cms_page" />,
          },
          {
            path: "cms/faq/list/:pgno",
            element: <PrivateRoute component={FAQTable} requiredPermission="faq" />,
          },
          {
            path: "cms/faq/add",
            element: <PrivateRoute component={FAQAdd} requiredPermission="faq" />,
          },
          {
            path: "cms/faq/:pgno/edit/:id",
            element: <PrivateRoute component={FAQEdit} requiredPermission="faq" />,
          },
          {
            path: "cms/faq/view/:id",
            element: <PrivateRoute component={FAQView} requiredPermission="faq" />,
          },
          // video section start
          {
            path: "cms/video/list/:pgno",
            element: <PrivateRoute component={VideoTable} requiredPermission="video" />,
          },
          {
            path: "cms/video/add",
            element: <PrivateRoute component={VideoAdd} requiredPermission="video" />,
          },
          {
            path: "cms/video/:pgno/edit/:id",
            element: <PrivateRoute component={VideoEdit} requiredPermission="video" />,
          },
          {
            path: "cms/video/view/:id",
            element: <PrivateRoute component={VideoView} requiredPermission="video" />,
          },

          {
            path: "cms/video/category/list/:pgno",
            element: <PrivateRoute component={VideoCategoryTable} requiredPermission="video" />,
          },
          {
            path: "cms/video/category/add",
            element: <PrivateRoute component={AddVideoCategory} requiredPermission="video" />,
          },
          {
            path: "cms/video/category/:pgno/edit/:id",
            element: <PrivateRoute component={EditVideoCategory} requiredPermission="video" />,
          },
          {
            path: "cms/video/category/view/:id",
            element: <PrivateRoute component={ViewVideoCategory} requiredPermission="video" />,
          },

           // video section end
          {
            path: "cms/blog/list/:pgno",
            element: <PrivateRoute component={BlogTable} requiredPermission="blog" />,
          },
          {
            path: "cms/blog/add",
            element: <PrivateRoute component={BlogAdd} requiredPermission="blog" />,
          },
          {
            path: "cms/blog/:pgno/edit/:id",
            element: <PrivateRoute component={BlogEdit} requiredPermission="blog" />,
          },
          {
            path: "cms/blog/view/:id",
            element: <PrivateRoute component={BlogView} requiredPermission="blog" />,
          },
          {
            path: "cms/banner/list/:pgno",
            element: <PrivateRoute component={BannerTable} requiredPermission="banner" />,
          },
          {
            path: "cms/banner/add",
            element: <PrivateRoute component={BannerAdd} requiredPermission="banner" />,
          },
          {
            path: "cms/banner/:pgno/edit/:id",
            element: <PrivateRoute component={BannerEdit} requiredPermission="banner" />,
          },
          {
            path: "cms/banner/view/:id",
            element: <PrivateRoute component={BannerView} requiredPermission="banner" />,
          },
          {
            path: "cms/about-us",
            element: <PrivateRoute component={AboutUsAdd} requiredPermission="about-us" />,
          },
          {
            path: "cms/expert-guidance",
            element: <PrivateRoute component={ExpertGuidance} requiredPermission="expert-guidance" />,
          },
          /** CMS Route End */
          {
            path: "inquiries/list/:pgno",
            element: <PrivateRoute component={InquiryTable} requiredPermission="inquires" />,
          },
          {
            path: "inquiries/view/:id",
            element: <PrivateRoute component={ViewInquiry} requiredPermission="inquires" />,
          },
          {
            path: "franchise-inquiries/list/:pgno",
            element: <PrivateRoute component={FranchiseInquiryTable}  requiredPermission="franchise-inquires" />,
          },
          {
            path: "franchise-inquiries/view/:id",
            element: <PrivateRoute component={ViewFranchiseInquiry}  requiredPermission="franchise-inquires" />,
          },
          {
            path: "permissions/add/:id",
            element: <PrivateRoute component={PermissionsTable} />,
          },
          {
            /** Doctor Management Route Start */
          },
          {
            path: "doctor-management/doctor/list/:pgno",
            element: <PrivateRoute component={DoctorList} requiredPermission="doctor_management" />,
          },
          {
            path: "doctor-management/doctor/add",
            element: <PrivateRoute component={DoctorAdd} requiredPermission="doctor_management" />,
          },
          {
            path: "doctor-management/doctor/add-more-details/:id",
            element: <PrivateRoute component={DoctorExtraDetails} requiredPermission="doctor_management" />,
          },
          {
            path: "doctor-management/doctor/view/:id",
            element: <PrivateRoute component={DoctorView} requiredPermission="doctor_management" />,
          },
          {
            path: "doctor-management/doctor/:pgno/edit/:id",
            element: <PrivateRoute component={DoctorEdit} requiredPermission="doctor_management" />,
          },
          {
            /** Doctor Management Route End */
            /** Patient Management Route Start */
          },
          {
            /** Patient Management Route End */
          },
          /** Medicine Management Route Start */
          {
            path: "medicine-management/medicine/list/:pgno",
            element: <PrivateRoute component={MedicineTable} requiredPermission="medicine_management" />,
          },
          {
            path: "medicine-management/medicine/add",
            element: <PrivateRoute component={AddMedicine} requiredPermission="medicine_management" />,
          },
          {
            path: "medicine-management/medicine/:pgno/edit/:id",
            element: <PrivateRoute component={MedicineEdit} requiredPermission="medicine_management" />,
          },
          {
            path: "medicine-management/medicine/view/:id",
            element: <PrivateRoute component={MedicineView} requiredPermission="medicine_management" />,
          },
          {
            /** Medicine Management Route End */
          },
           /** Medical Conditions Route Start */
          {
            path: "medical-conditions/list/:pgno",
            element: <PrivateRoute component={MedicalConditionsTable} requiredPermission="medical_conditions" />,
          },
          {
            path: "medical-conditions/add",
            element: <PrivateRoute component={AddMedicalCondition} requiredPermission="medical_conditions" />,
          },
          {
            path: "medical-conditions/:pgno/edit/:id",
            element: <PrivateRoute component={EditMedicalCondition} requiredPermission="medical_conditions" />,
          },
          {
            path: "medical-conditions/view/:id",
            element: <PrivateRoute component={ViewMedicalCondition} requiredPermission="medical_conditions" />,
          },
          {
            /** Medical Conditions Route End */
          },

          {
            /**Email Template Management Route Start */
          },
          {
            path: "email-template/list/:pgno",
            element: <PrivateRoute component={EmailTemplatesTable} requiredPermission="email_template" />,
          },
          {
            path: "email-template/view/:id",
            element: <PrivateRoute component={ViewEmailTemp} requiredPermission="email_template" />,
          },
          {
            path: "email-template/add",
            element: <PrivateRoute component={EmailTempAdd} requiredPermission="email_template" />,
          },
          {
            path: "email-template/:pgno/edit/:id",
            element: <PrivateRoute component={EmailTempEdit} requiredPermission="email_template" />,
          },
          {
            /**Email Template Management Route End */
          },

          {
            path: "doctor-specialization/list/:pgno",
            element: <PrivateRoute component={DoctorSpecializationTable} requiredPermission="doctor-specialization" />,
          },
          {
            path: "doctor-specialization/view/:id",
            element: <PrivateRoute component={DoctorSpecializationView} requiredPermission="doctor-specialization" />,
          },
          {
            path: "doctor-specialization/add",
            element: <PrivateRoute component={AddDoctorSpecialization} requiredPermission="doctor-specialization" />,
          },
          {
            path: "doctor-specialization/:pgno/edit/:id",
            element: <PrivateRoute component={DoctorSpecializationEdit} requiredPermission="doctor-specialization" />,
          },

          /**General Settings Route Start */
          {
            path: "general-settings",
            element: <PrivateRoute component={GlobalSettings} requiredPermission="general_settings" />,
          },
          /**General Settings Route End */

          /** Reports Route Start */
          {
            path: "report-management",
            element: <PrivateRoute component={ReportView} requiredPermission="report-management" />,
            children: [
              {
                path: "patient/list/:pgno",
                element: <PrivateRoute component={PatientReportTables} requiredPermission="report-management" />,
              },
              {
                path: "medicine/list/:pgno",
                element: <PrivateRoute component={MedicineReportTable} requiredPermission="report-management" />,
              },
              {
                path: "earning-report/list/:pgno",
                element: <PrivateRoute component={EarningReportTable} requiredPermission="report-management" />,
              },
            ],
          },
          /** Reports Route End */

          /** Appointment Management (Staff) Route Start */
          {
            path: "management-section",
            element: <PrivateRoute component={AppointmentsView} requiredPermission="management-section" />,
            children: [
              {
                path: "upcoming-appointment/list/:pgno",
                element: <PrivateRoute component={UpcomingAppointmentsTables} requiredPermission="management-section" />,
              },
              {
                path: "completed-appointment/list/:pgno",
                element: <PrivateRoute component={AppointmentsTables} requiredPermission="management-section" />,
              },
              {
                path: "feedback-appointment/list/:pgno",
                element: <PrivateRoute component={AppointmentsFeedbackTables} requiredPermission="management-section" />,
              },
              {
                path: "cancelled-appointment/list/:pgno",
                element: <PrivateRoute component={AppointmentsCancelledTables} requiredPermission="management-section" />,
              },
              {
                path: "expired-appointment/list/:pgno",
                element: <PrivateRoute component={ExpiredAppointmentsTables} requiredPermission="management-section" />,
              },
            ],
          },
          {
            path: "management-section/completed-appointment/view/list/:pgno",
            element: <PrivateRoute component={AppointmentHistory} requiredPermission="management-section" />,
          },
          /** Appointment Management (Staff) Route End */
        ],
      },
      {
        path: "admin",
        element: <AdminUnAuthLayout />,
        children: [
          { path: "login", element: <PublicRoute component={Login} /> },
          {
            path: "forget-password",
            element: <PublicRoute component={ForgotPwdPage} />,
          },
          {
            path: "otp-verification/:email",
            element: <PublicRoute component={OtpVerificationPage} />,
          },
          {
            path: "reset-password",
            // element: localStorage.getItem("validate_string") ? <PrivateRoute component={ResetPwdPage} /> : <Navigate to="/admin/login" />
            element: <PublicRoute component={ResetPwdPage} />,
          },
        ],
      },

      { path: "admin/*", element: <Error404 /> },
      /**ADMIN ROUTE END */

      { path: "*", element: <Page404 homePath="/" /> },
    ],

  },


  /** CENTER ROUTE START */
  {
    path: "center",
    element: <CenterPrivateRoute component={CenterLayout} />,
    children: [
      {
        path: "",
        element: <Navigate to={"/center/dashboard/:page"} />,
      },
      {
        path: "dashboard/:page",
        element: <CenterPrivateRoute component={CenterDashboard} />,
      },
      {
        path: "profile",
        children: [
          {
            path: "",
            element: <CenterPrivateRoute component={CenterProfile} />,
          },
          {
            path: "change-password",
            element: (
              <CenterPrivateRoute component={CenterProfileChangePassword} />
            ),
          },
        ],
      },
      {
        path: "settings/doctor/:page",
        element: <CenterPrivateRoute component={Doctor} />,
      },
      {
        path: `settings/doctor/schedule/:page`,
        element: <CenterPrivateRoute component={Schedule} />,
      },
      {
        path: `patient/:page`,
        element: <CenterPrivateRoute component={Patients} />,
      },
      {
        path: `patient/appointment/:patientId/:page`,
        element: <CenterPrivateRoute component={Appointment} />,
      },
      {
        path: `patient/appointment/view/:id`,
        element: <CenterPrivateRoute component={CenterPatientView} />,
      },
      {
        path: "patient/medical-history/view",
        element: <CenterDoctorPrivateRoute component={MedicalHistoryView} role={ROLE.CENTER} />,
      },
      {
        path: "wallet/:page",
        element: <CenterPrivateRoute component={Wallet} />,
      },
      { path: "*", element: <Page404 homePath="/center/dashboard/1" /> },
    ],
  },
  /** CENTER ROUTE END */

  {
    path: "select-user",
    element: <SelectUser />
  },

  /** CENTER AUTH ROUTE START */
  {
    path: "center",
    element: <CenterPublicRoute component={CenterAuthLayout} />,
    children: [
      {
        path: "",
        element: <Navigate to={"/center/dashboard/1"} />
      },
      {
        path: "login",
        element: <CenterPublicRoute component={CenterLogin} />,
      },
      {
        path: "forget-password",
        element: <CenterPublicRoute component={CenterForgotPwdPage} />,
      },
      {
        path: "reset-password",
        element: <CenterPublicRoute component={CenterResetPassword} />,
      },
      {
        path: "otp-verification",
        element: <CenterPublicRoute component={Verifyotp} />,
      },
      { path: "*", element: <Page404 homePath="/center" /> },
    ],
  },

  /** DOCTOR ROUTE START */
  {
    path: "doctor",
    element: <DoctorPrivateRoute component={DoctorLayout} />,
    children: [
      {
        path: "",
        element: <Navigate to={"/doctor/dashboard/:page"} />,
      },
      {
        path: "dashboard/:page",
        element: <DoctorPrivateRoute component={DoctorDashboard} />,
      },
      {
        path: "profile",
        children: [
          {
            path: "",
            element: <DoctorPrivateRoute component={DoctorMyProfile} />,
          },
          {
            path: "change-password",
            element: (
              <DoctorPrivateRoute component={DoctorProfileChangePassword} />
            ),
          },
        ],
      },
      {
        path: "settings/patient/:page",
        // element: <Patient />,
        element: (
          <DoctorPrivateRoute component={Patient} />
        ),
      },
      // {
      //   path: `patient/appointment/:page`,
      //   element: <DoctorPrivateRoute component={PatientAppointment} />,
      // },
      {
        path: "patient/appointment/:patientId/:page",
        element: <DoctorPrivateRoute component={PatientAppointment} />,
      },
      {
        path: "patient/appointment/view/:id",
        element: <DoctorPrivateRoute component={PatientView} />,
      },
      {
        path: "patient/medical-history/view",
        element: <CenterDoctorPrivateRoute component={MedicalHistoryView} role={ROLE.DOCTOR}/>,
      },
      {
        path: "consultation-history/:page",
        element: <DoctorPrivateRoute component={ConsultationHistory} />,
      },
      {
        path: "consultation-history/view/:id",
        element: <DoctorPrivateRoute component={ConsultationHistoryView} />,
      },
      {
        path: "consultation/medical-history/view",
        element: <DoctorPrivateRoute component={ConsultationMedicalHistoryView} />,
      },
      {
        path: "consultation/prescription/add",
        element: <DoctorPrivateRoute component={PrescriptionCreate} />,
      },
      {
        path: "consultation/prescription/edit/:id",
        element: <DoctorPrivateRoute component={PrescriptionEdit} />,
      },
      {
        path: "consultation/prescription/view/:id",
        element: <DoctorPrivateRoute component={PrescriptionView} />,
      },
      {
        path: "patient/diet-chart/add",
        element: <DoctorPrivateRoute component={PatientDietChart} />,
      },
      { path: "*", element: <Page404 homePath="/doctor/dashboard" /> },
    ],
  },
  /** DOCTOR ROUTE END */

  /** DOCTOR AUTH ROUTE START */
  {
    path: "doctor",
    element: <CenterPublicRoute component={DoctorAuthLayout} />,
    children: [
      {
        path: "",
        element: <Navigate to={"/doctor/dashboard"} />
      },
      {
        path: "login",
        element: <CenterPublicRoute component={CenterLogin} />,
      },
      {
        path: "forget-password",
        element: <CenterPublicRoute component={CenterForgotPwdPage} />,
      },
      {
        path: "reset-password",
        element: <CenterPublicRoute component={CenterResetPassword} />,
      },
      {
        path: "otp-verification",
        element: <CenterPublicRoute component={Verifyotp} />,
      },
      { path: "*", element: <Page404 homePath="/doctor" /> },
    ],
  },
]);

export default router;
